export const addLatePayment = {
  name:'',
  interest_index:'',
  margin:null,
  description:''
}
export const LatePaymentHd = [
  { label: 'Name', sortOption: false },
  { label: 'Interest Index', sortOption: false },
  { label: 'Margin(%)', sortOption: false },
  { label: 'Description', sortOption: false },
  { label: 'Attachment(s)', sortOption: false },
  { label: 'Action(s)', sortOption: false },
];
export const errorCode = {
  name:{
    0:'',
    1: 'Please enter Name '
  },
  latepaymentObj: {
    required: true
  }
}
